import React from "react";
import _ from "lodash";
import { Link } from "react-router-dom";
import { gateKeeper } from "./actions";
import { connect } from "react-redux";
import styles from "./confirm-account.module.scss";

class ConfirmAccount extends React.Component<any, any> {
  componentDidMount() {
    this.props.gateKeeper();
  }

  render() {
    const { username } = this.props;
    return (
      <div className={styles.wrapper}>
        <div className="warning-message">
          <p>
            We have sent the activation link to your email address: {username}.
          </p>
          <p>Please also check your spam folder for the confirmation email!</p>
          <p>
            Once your account is activated, please{" "}
            <Link to={"/login" + window.location.search}>log in</Link>.
          </p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  username: _.get(state, "signUp.user.user.username", ""),
});

const mapDispatchToProps = {
  gateKeeper,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmAccount);
